/** Saves a license key as a plain-text .license file — the file contains
 * nothing but the raw key, for a tenant to drop into their own config. */
export function downloadLicenseFile(tenantId: string, licenseKey: string) {
  const blob = new Blob([licenseKey], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${tenantId}.license`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
